export default __webpack_public_path__ + "static/media/dash-breezy.54ed5eec.svg";